import React from 'react';
import { Thumbnail } from '@bynder/design-system';
import { IconNotifications } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

import { ListContent, ListInfo, ListTitle, ListSecondary, ListAction } from './styles';

export function StayNotified({ children }: { children: React.ReactNode }) {
	const { translate } = useTranslate();

	return (
		<ListContent>
			<Thumbnail variant="clean" icon={<IconNotifications />} />
			<ListInfo>
				<ListTitle>{translate('user-outofoffice.KeepReceivingNotifications')}</ListTitle>
				<ListSecondary>
					{translate('user-outofoffice.Description.KeepReceivingNotifications')}
				</ListSecondary>
			</ListInfo>
			<ListAction>{children}</ListAction>
		</ListContent>
	);
}
